import { Card, Divider, Grid } from '@mui/material';
import { GeneralTable } from 'src/components/general';
import { CHANNEL_SELECTION_TABLE_HEAD } from 'src/constants/tableHeads';
import useTable from 'src/hooks/useTable';
import ChannelSelectionTableRow from './ChannelSelectionTableRow';

// ----------------------------------------------------------------------

export default function ChannelSelectionTableModal({ selectContentHandler, isLoading, tableData }) {
  const useTableOptions = useTable();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ p: 3, overflow: 'visible' }}>
          {/* <ContentSelectionTableToolbar setFilterItems={setFilterItems} onChangePage={onChangePage} /> */}

          <Divider sx={{ my: 2 }} />

          <GeneralTable
            tableContainerSX={{
              position: 'relative',
              maxHeight: { xs: 'calc(100dvh - 250px)', lg: 'calc(100dvh - 180px)' },
            }}
            rowID="SocialManagerChannelID"
            tableData={tableData}
            headLabel={CHANNEL_SELECTION_TABLE_HEAD}
            CustomTableRow={ChannelSelectionTableRow}
            useTableOptions={useTableOptions}
            hasDeleteOption={false}
            selectContentHandler={selectContentHandler}
            isLoading={isLoading}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
